import type { EventTargetParameter } from '@vlabs/api/artemy/model';

export const EVENT_TARGET: EventTargetParameter = [
  'event_id', 'create_time', 'end_time', 'handler_id', 'face_id', 'external_id',
  'source', 'stream_id', 'tags', 'track_id', 'user_data', 'location', 'top_match',
  'match_result', 'attach_result', 'face_detections', 'body_detections', 'gender',
  'age', 'ethnic_group', 'liveness', 'deepfake', 'emotion', 'mask',
  'body_basic_attributes', 'upper_body', 'lower_body', 'accessories', 'meta',
  'permission_tag',
];
